import { IconButton, Paper, Stack } from "@mui/material";
import { useBarrierPoints, useRouteLocationActions } from "../../stores/RouteLocationStore";
import DeleteIcon from '@mui/icons-material/Delete';
import { AddressItem } from "../../services/GeocodeService";

export function BarrierPointMenu() {
    const barrierPoints = useBarrierPoints();
    const { removeBarrierPoint } = useRouteLocationActions();

    const sortedBarrierPoints = barrierPoints.sort( (a,b) => a.order < b.order ? -1:1 )
    return (        
        <>
        {barrierPoints && barrierPoints.length > 0 &&
        <Stack spacing={1}>
            {
                sortedBarrierPoints.map( (barrierPoint:AddressItem, index: number) => {
                    const name = "Blokkering: " + barrierPoint.name;
                    return (
                        <Paper key={"BarrierPointMenu" + index}>
                            <p style={{float:"left"}}>{name}</p>                            
                            <IconButton style={{float: "right", textAlign:"center"}} onClick={ () => {
                                    removeBarrierPoint(barrierPoint)
                                }}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Paper>
                    );
                })
            }
            </Stack>
        }
        </>
    )
}